import * as React from "react";
import {DEF} from "../../const";
import Box from "@mui/material/Box";
import DateRangePicker from "../DateRangePicker";
import {Button} from "@mui/material";
import {useEffect, useState} from "react";
import dayjs from "dayjs";
import {GoodTable} from "./GoodTable";
import ErrorInfo, {ErrorInfoState} from "../../Components/UI/Info/ErrorInfo";
import WarningInfo, {WarningInfoState} from "../../Components/UI/Info/WarningInfo";
import SuccessInfo, {SuccessInfoState} from "../../Components/UI/Info/SuccessInfo";
import axios from "axios";
import {getUrl} from "../../requests";
import {Libs} from "../../App/libs";
import clsx from "clsx";
import css from "./GoodReport.module.css";

const GoodReport = (props) => {
    const [dateFrom, setDateFrom] = useState(props?.dateFrom ? props.dateFrom : dayjs(new Date()).add(-2, "month").toDate());
    const [dateTo, setDateTo] = useState(props?.dateTo ? props?.dateTo : new Date());

    const [dateError, setDateError] = useState("");
    const [data, setData] = useState([]);

    const [messageState, setMessageState] = useState(SuccessInfoState);
    const [errorState, setErrorState] = useState(ErrorInfoState);
    const [warningState, setWarningState] = useState(WarningInfoState);
    const [isInitialized, setIsInitialized] = useState(false);
    const [disableReport, setDisableReport] = useState(false);
    const [disableReportToDisk, setDisableReportToDisk] = useState(true);
    const [disableReportToGoogle, setDisableReportToGoogle] = useState(true);

    useEffect(() => {
        if(dateError) {
            setErrorState(errorState => ({...errorState, msg: dateError}));
            setDateError('');
        }
    }, [dateError]);

    useEffect(() => {
        if (isInitialized) {
            setMessageState(messageState => ({...messageState, msg: ''}));
            setDisableReportToDisk(true);
            setDisableReportToGoogle(true);
            setData([]);
        }
        setIsInitialized(true);
    }, [dateFrom, dateTo]);

    const getJson = async () => {
        setData([]);
        const dF = dayjs(dateFrom).format(DEF.DATE_FORMAT);
        const dT = dayjs(dateTo).format(DEF.DATE_FORMAT);
        setMessageState(messageState => ({...messageState,
            msg: 'Generowanie raportu...',
            show: DEF.POPUP_SHOWING_INFINITE_TIME
        }));

        try {
            let request = {
                headers: {
                    Authorization: `Bearer ${props?.auth?.user}`,
                },
                params : {
                    dateFrom: dF,
                    dateTo: dT,
                }
            };

            const response = await axios.get(`${getUrl()}/api/v1/reports/goods-json`, request);

            if (response.status === 200 && Array.isArray(response.data)) {
                if(response.data.length > 0)
                {
                    setMessageState(messageState => ({...messageState,
                        msg:'Pobranych rekordów: ' + response.data.length,
                        show: DEF.POPUP_SHOWING_DEFAULT_TIME
                    }));
                    setData(response.data);
                    setDisableReportToDisk(false);
                    setDisableReportToGoogle(false);
                } else {
                    setMessageState(messageState => ({...messageState, msg: ''}));
                    setWarningState(warningState => ({...warningState, msg: 'Brak danych.'}));
                }
            } else {
                const error = Libs.handleError(response);
                console.error(error);
                setMessageState(messageState => ({...messageState, msg: ''}));
                setErrorState(errorState => ({...errorState, msg: error.message}));
            }

        } catch (ex) {
            const error = Libs.handleError(ex);
            console.error(error);
            setMessageState(messageState => ({...messageState, msg: ''}));
            setErrorState(errorState => ({...errorState, msg: error.message}));
        }
    }

    const getCsvFile = async () => {
        const dF = dayjs(dateFrom).format(DEF.DATE_FORMAT);
        const dT = dayjs(dateTo).format(DEF.DATE_FORMAT);
        let fileName = `dobro-${dF}-${dT}.csv`;
        setMessageState(messageState => ({...messageState,
            msg: "Pobieranie raportu...",
            show: DEF.POPUP_SHOWING_INFINITE_TIME
        }));

        try {
            let request = {
                responseType: "blob",
                headers: {
                    Authorization: `Bearer ${props?.auth?.user}`,
                },
                params: {
                    dateFrom: dF,
                    dateTo: dT,
                }
            };

            const response = await axios.get(`${getUrl()}/api/v1/reports/goods-csv`, request);
            if(response.status === 200 )
            {
                const reader = new FileReader();
                reader.onloadend = () => {
                    const link = document.createElement('a');
                    link.href = reader.result;
                    link.download = fileName;

                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                };
                reader.readAsDataURL(new Blob([response.data], { type: 'text/csv' }));

                setMessageState(messageState => ({...messageState,
                    msg: 'Pobrano plik na dysk. ' + fileName,
                    show: DEF.POPUP_SHOWING_DEFAULT_TIME,
                }));
            } else {
                setErrorState(errorState => ({...errorState, msg: 'Błąd podczas pobierania pliku: ' + fileName,}));
                setMessageState(messageState => ({...messageState, msg: ''}));
            }
        } catch (ex) {
            console.error(ex);
            setErrorState(errorState => ({...errorState, msg:"Błąd podczas pobierania pliku: " + fileName}));
            setMessageState(messageState => ({...messageState, msg: ''}));
        }
    }

    const saveCsvToGDrive = async () => {
        const dF = dayjs(dateFrom).format(DEF.DATE_FORMAT);
        const dT = dayjs(dateTo).format(DEF.DATE_FORMAT);
        const fileName = `dobro-${dF}-${dT}.csv`;
        setMessageState(messageState => ({...messageState,
            msg: 'Przesyłanie raportu na Dysk Google...',
            show: DEF.POPUP_SHOWING_INFINITE_TIME
        }));

        try {
            const request = {
                headers:
                {
                    Authorization: `Bearer ${props?.auth?.user}`,
                },
                params :
                {
                    dateFrom: dF,
                    dateTo: dT,
                }
            };

            const response = await axios.get(`${getUrl()}/api/v1/reports/goods-csv-to-gdrive`, request);

            if (response.status === 200) {
                const link = <a href={response.data}
                                target="_blank"
                                rel="noopener noreferrer">Otwórz: {fileName}
                </a>;

                setMessageState( messageState => ({...messageState,
                    msg: link,
                    show: DEF.POPUP_SHOWING_MANUAL_CLOSE,
                }));
            } else {
                console.error('Nie udało się wygenerować raportu.', response.status , response.data);
                setMessageState(messageState => ({...messageState, msg: ''}));
                setErrorState(errorState => ({...errorState,
                    msg:"Błąd podczas zapisywania pliku na gdrive: " + fileName,
                    show: DEF.POPUP_SHOWING_MANUAL_CLOSE
                }));
            }
        } catch (ex) {
            console.error(ex);
            setErrorState(errorState => ({...errorState,
                msg:"Błąd podczas zapisywania pliku na gdrive: " + fileName,
                show: DEF.POPUP_SHOWING_MANUAL_CLOSE
            }));
            setMessageState(messageState => ({...messageState, msg: ''}));
        }
    }

    return (
        <Box className={clsx(css.goodReport)}>
            <Box className={clsx(css.controlPanel, 'controlPanel')}>
                <DateRangePicker
                    setDateFrom={setDateFrom}
                    setDateTo={setDateTo}
                    dateFrom={dateFrom}
                    dateTo={dateTo}
                    setDateError={setDateError}
                    inputFormat='YYYY-MM-DD'
                    mask='____-__-__'
                />

                <Button id='good-report-btn-get-json' className='button'
                        variant="contained"
                        disabled={disableReport}
                        onClick={getJson}
                >
                    Generuj <br/> raport
                </Button>

                <Button id='good-report-btn-get-csv' className='button'
                        variant="contained"
                        disabled={disableReportToDisk}
                        onClick={getCsvFile}
                >
                    Plik na <br/>dysk
                </Button>

                <Button  id='good-report-btn-csv-to-gdrive' className='button'
                        variant="contained"
                        disabled={disableReportToGoogle}
                        onClick={saveCsvToGDrive}
                >
                    Plik na <br/> google
                </Button>
            </Box>

            {errorState.msg && <ErrorInfo state={errorState} setState={setErrorState}/>}
            {warningState.msg && <WarningInfo state={warningState} setState={setWarningState}/>}
            {messageState.msg && <SuccessInfo state={messageState} setState={setMessageState}/>}

            <Box className={clsx(css.scrollable, 'scrollable')}>
                <GoodTable
                    data={data}
                />
            </Box>
        </Box>

    )

};

export default GoodReport;